import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { usePlanCardContext } from '../../context';
import * as Styled from './styles';
import type { PlanTitleProps as Props } from './types';

export const PlanTitle = memo(({ className }: Props) => {
  const { isPaid, title, isMostPopular, isCompact } = usePlanCardContext();
  const displayTitle = title || (isPaid ? 'Usage-Based Plan' : 'Free Plan');

  const color =
    isCompact && isMostPopular
      ? 'common.white'
      : isCompact
      ? 'grey.700'
      : isMostPopular
      ? 'common.white'
      : 'grey.700';

  return (
    <Styled.Wrapper
      className={classnames('PlanTitle', className)}
      color={color}
      fontWeight={700}
      variant={isCompact ? 'body4' : 'body1'}
      mt={1}
      mb={1}
      textAlign="left"
    >
      {displayTitle}
    </Styled.Wrapper>
  );
});

PlanTitle.displayName = 'PlanTitle';
